import { createContext, useContext, useState, ReactNode } from 'react';

export type FiltersState = Partial<Record<string, string | number | boolean>>;

interface GridContextType {
  filtersState: FiltersState | undefined;
  setFiltersState: (filters: FiltersState | undefined) => void;
  isFiltered: boolean;
  setIsFiltered: (isFiltered: boolean) => void;
}

const GridContext = createContext<GridContextType | undefined>(undefined);

export function GridProvider({ children }: { children: ReactNode }) {
  const [filtersState, setFiltersState] = useState<FiltersState | undefined>();
  const [isFiltered, setIsFiltered] = useState(false);

  return (
    <GridContext.Provider
      value={{
        filtersState,
        setFiltersState,
        isFiltered,
        setIsFiltered
      }}
    >
      {children}
    </GridContext.Provider>
  );
}

export const useGridContext = () => {
  const context = useContext(GridContext);
  if (context === undefined) {
    throw new Error('useGridContext must be used within a GridProvider');
  }
  return context;
};
